//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  inheritAttrs: false,

  props: {
    to: {
      type: String,
      default: '/'
    },

    size: {
      type: String,
      default: 'regular',
      validator: (value) => {
        return [
          'regular',
          'small',
          'xs'
        ].includes(value)
      }
    },

    shape: {
      type: String,
      default: 'rectangle',
      validator: (value) => {
        return [
          'rectangle',
          'circle'
        ].includes(value)
      }
    },

    nativeType: {
      type: String,
      default: 'button',
      validator: (value) => {
        return [
          'button',
          'submit',
          'reset'
        ].includes(value)
      }
    },

    tag: {
      type: String,
      default: 'button',
      validator: (value) => {
        return [
          'a',
          'button',
          'n-link',
          'sg-link',
          'base-link'
        ].includes(value)
      }
    },

    grow: {
      type: Boolean,
      default: false
    },

    noFocus: {
      type: Boolean,
      default: false
    },

    uppercase: {
      type: Boolean,
      default: false
    },

    target: {
      type: String,
      default: '_blank',
      validator: (value) => {
        return [
          '_self',
          '_blank'
        ].includes(value)
      }
    }
  },

  computed: {
    computedTag () {
      if (this.$attrs.disabled !== undefined && this.$attrs.disabled !== false) {
        return 'button'
      }
      return this.tag
    },

    classes () {
      return {
        [`BaseButton--${this.size}`]: this.size,
        [`BaseButton--${this.shape}`]: this.shape,
        'BaseButton--grow': this.grow,
        'BaseButton--no-focus': this.noFocus
      }
    }
  }
}
